module.exports = __webpack_public_path__ + "img/Trophy Cup Table29.99a57ab7.jpg";